import styled from 'styled-components';
import BaseListBox from 'components/ListBox';

export const ListBox = styled(BaseListBox).attrs({
  density: 'comfortable',
})`
  border-radius: inherit;
`;
